import RaceCalendar from "./raceCalendar";

export default function PrivateRaceCalendar() {
    return (
        <RaceCalendar target='/racelive/%SOURCE%/%RxCx%'/>
    )
}
